<div class="w-100" [style.height.px]="innerHeight" *ngIf="loading || loadingRuleEngineActions || loadingPositionStatements || loadingAllDataDetails">
    <div class="loading-small-screen-scroll trst w-auto">
        <img src="assets/images/landing-page/loading-more.svg" alt="Loader"/>
        <div class="col-12 text-center"> Generating Report
            <div class="loader-dots"></div>
        </div>
        <div class="col-12 text-center">
            Please wait
            <div class="loader-dots"></div>
        </div>
        <div class="col-12 text-center">
            Loading ALLDATA Details
            <div class="loader-dots" *ngIf="loadingAllDataDetails"></div>
            <i class="fa-regular fa-circle-check check-icon" *ngIf="!loadingAllDataDetails"></i>
        </div>
        <div class="col-12 text-center">
            Loading Position Statements
            <div class="loader-dots" *ngIf="loadingPositionStatements"></div>
            <i class="fa-regular fa-circle-check check-icon" *ngIf="!loadingPositionStatements"></i>
        </div>
        <div class="col-12 text-center">
            Processing Rule Engines
            <div class="loader-dots" *ngIf="loadingRuleEngineActions"></div>
            <i class="fa-regular fa-circle-check check-icon" *ngIf="!loadingRuleEngineActions"></i>
        </div>
    </div>
</div>
<div class="w-100" style="height: 100vh;" *ngIf="updating">
    <div class="loading-small-screen-scroll trst w-auto">
        <img src="assets/images/landing-page/loading-more.svg" alt="Loader"/>
        <div class="col-12 text-center"> Updating Report
            <div class="loader-dots"></div>
        </div>
        <div class="col-12 text-center">
            Please wait
            <div class="loader-dots"></div>
        </div>
    </div>
</div>
<div class="loading-container hide">
    <div class="spinner-circle">
        <div class="dots-container">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
        </div>
    </div>
    <div class="loading-text">Loading Report..</div>
</div>

<div class="w-100" style="height: 100vh;" *ngIf="removeLoading">
    <div class="loading-small-screen-scroll trst w-auto">
        <img src="assets/images/landing-page/loading-more.svg" alt="Loader"/>
        <div class="col-12 text-center"> Removing Report
            <div class="loader-dots"></div>
        </div>
        <div class="col-12 text-center">
            Please wait
            <div class="loader-dots"></div>
        </div>
    </div>
</div>
<ng-container *ngIf="!thirdPartyReport.id">
<div *ngIf="emptyFlag && !(updating || removeLoading || loading || loadingRuleEngineActions || loadingPositionStatements || loadingAllDataDetails)" id="calprosec">
    <!-- Empty Container -->
    <div class="list">
        <div class="documents-grid-row documents-grid-row-new adas-empty" [style.height.px]="innerHeight">
            <app-empty-container [adasReportAction]="roReportMapFlag" [adasReportActionText]="'Attach ADAS Report'" [showType]="displayNoRecordsShow" [contentTypeDefaultNewText]="emptyContentType" [contentTypeDefaultNewImg]="emptyContentImg" (adasReportActionEmit)="adasReportActionCallaback()"></app-empty-container>
        </div>
    </div>
</div>
<div *ngIf="!emptyFlag && !updating && !removeLoading && !loading && !loadingRuleEngineActions && isNewReport && !loadingPositionStatements && !loadingAllDataDetails"
     class="" [ngClass]="{'justify-content-center align-items-center': pageName == 'scannedVINs' || pageName == 'nweROscannedVINs'}">
    <div id="calprosec">
        <div class="detail-section business-info row col-12">
            <div class="col-8 col-lg-8 col-md-6 col-sm-12 domain-info">
                <div class="row-head2 pt-3">CalPro ADAS Report</div>
                <div class="date pt-3"><i class="fa fa-calendar" aria-hidden="true"></i>
                    Date: {{inspectionData.createdOnDate | date : 'MMM d, y' }} (Patent 11,210,869)
                </div>
                <br/>
                <div class="row-head pt-3">{{businessData.domainName}}</div>
                <div *ngIf="businessData.address != ''" class="split-bg-row addr">{{businessData.address}}</div>
                <!--div class="split-bg-row email">-</div-->
                <div *ngIf="businessData.phone != ''" class="split-bg-row phone">{{businessData.phone}}</div>
                <div class="empty-row"></div>
                <div class="split-bg-row market">
                    <span class="split-col label">Market: </span>
                    <span class="split-col value">{{inspectionData.market != '' ? inspectionData.market : '-'}}</span>
                </div>
                <div class="split-bg-row sales-rep hide">
                    <span class="split-col label">Sales Person: </span>
                    <span class="split-col value">{{inspectionData.salesPerson != '' ? inspectionData.salesPerson : '-'}}</span>
                </div>
            </div>
            <div class="col-4 col-lg-4 col-md-6 col-sm-12 report-info">
                <div class="p-3 float-right">
                    <button class="btn add-btn report-action-btn mr-1 mt-1 p-1" (click)="openRepairOrderPOPUP('new', '')" *ngIf="!roFlag && showCreateRO && pageName != 'nweROscannedVINs'">
                        <img src="assets/images/adas/report-icons/report_ro.svg" style="margin-top: -5px;" height="14"/> &nbsp;&nbsp;Create RO
                    </button>
                    <button class="btn add-btn report-action-btn mr-1 mt-1 p-1 pl-2" (click)="isEditReport = true" *ngIf="!isEditReport && !v3Report && (pageName == 'scannedVINs' || pageName != 'nweROscannedVINs')">
                        <img src="assets/images/adas/report-icons/report_edit.svg" style="margin-top: -5px;" height="14"/> &nbsp;&nbsp;Edit
                    </button>
                    <button class="btn add-btn report-action-btn mr-1 mt-1 p-1 pl-2" (click)="downloadEstimate()" *ngIf="reportCreatedByType == 3">
                        <img src="assets/images/adas/report-icons/report_download.svg" style="margin-top: -5px;" height="14"/> &nbsp;&nbsp;Download original Estimate
                    </button>
                    <button class="btn add-btn report-action-btn mr-1 mt-1 p-1" (click)="isEditReport = false; saveReport()" *ngIf="isEditReport">
                        <i style="margin-right: 5px; font-size: 14px;" class="pi pi-check"></i>&nbsp;&nbsp;Save
                    </button>
                    <button class="btn add-btn report-action-btn p-1 mt-1 ml-2" (click)="isEditReport = false" *ngIf="isEditReport">
                        <i class="pi pi-times"></i> &nbsp;&nbsp;Cancel
                    </button>
                    <span *ngIf="pageName != 'scannedVINs' && pageName != 'nweROscannedVINs'" class="view-pdf cursor mr-1 mt-1" style="position: unset">
                        <a class="download-pdf" target="_blank" href="{{inspectionData.pdfUrl}}" style="font-size: 12px;">
                            <span>
                                <img src="assets/images/gts/adobe.png" alt="" style="width: 18px;"></span>
                            View PDF
                        </a>
                    </span>
                </div>
                <div class="split-row report-id pt-5">
                    <span class="split-col label">Report ID: </span>
                    <span class="split-col value">{{inspectionData.id}}</span>
                </div>
                <div class="split-row report-date hide">
                    <span class="split-col label">Report Date: </span>
                    <span class="split-col value">{{inspectionData.createdOnDate}}</span>
                </div>
                <div *ngIf="roFlag">
                    <div class="split-row ro-id">
                        <span class="split-col label">RO ID: </span>
                        <span class="split-col value">
                            <a [href]="'/repair-order/view/' + inspectionData.workOrderId" target="_blank">
                                {{inspectionData.workOrderId}}
                            </a>
                        </span>
                    </div>
                    <div class="split-row ref-shop">
                        <span class="split-col label">Shop RO#: </span>
                        <span class="split-col value">{{roShopRef}}</span>
                    </div>
                </div>
                <div *ngIf="customerDataFlag">
                    <div class="empty-row"></div>
                    <div class="row-head">{{customerInfo.name}}</div>
                    <div class="split-bg-row addr">{{customerInfo.address}}</div>
                    <div class="split-bg-row email">{{customerInfo.email}}</div>
                    <div *ngIf="customerInfo.phone != ''" class="split-bg-row phone">{{customerInfo.phone}}</div>
                    <div *ngIf="contactDataFlag">
                        <div class="empty-row"></div>
                        <div class="row-head sub-head">Customer Contact</div>
                        <div class="split-bg-row user">{{contactInfo.firstName}} {{contactInfo.lastName}}</div>
                        <div class="split-bg-row email">{{contactInfo.email}}</div>
                        <div *ngIf="contactInfo.phoneNumber != ''" class="split-bg-row phone">{{contactInfo.phoneNumber}}</div>
                    </div>
                    <div class="empty-row"></div>
                </div>
                <div *ngFor="let rInfo of additionalReportInfo; let i = index">
                    <div class="split-row ref-shop">
                        <span class="split-col label">{{rInfo.label}}: </span>
                        <span class="split-col value">{{rInfo.value}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="section-divider-gap"></div>
        <div class="detail-section pt-1 pb-1">
            <div class="detail-info inspection-survey p-0">
                <h3 class="h3-bgclass detail-head car-icon">Section 1: Vehicle Info</h3>
            </div>
        </div>

        <div class="detail-row">
            <div class="row col-12">
                <div class="banner-section col-6">
                    <div class="bs-col banner">
                        <div class="banner-image" [ngStyle]="{'background-image': 'url(' + logo + ')'}"></div>
                    </div>
                    <div class="bs-col vin-info">
                        <div class="vin-no">
                            VIN: {{inspectionData.vinNo}}
                            <span class="cursor copy" title="Copy Link" (click)="copyLink(inspectionData.vinNo);"></span>
                            <div *ngIf="copiedModal" class="copied-txt-div">
                                <div class="copied-txt-inner-div">VIN Copied</div>
                            </div>
                        </div>
                        <div class="vinfo">
                            <span *ngIf="resultData.year">{{resultData.year}}</span>
                            <span *ngIf="resultData.make">&nbsp;{{resultData.make}}</span>
                            <span *ngIf="resultData.model">&nbsp;{{resultData.model}}</span>
                            <span *ngIf="resultData?.vehicles?.length">
              &nbsp;{{resultData?.vehicles[0].styleDescription}}
                                &nbsp;{{resultData?.vehicles[0].driveType}}
                                &nbsp;{{resultData?.vehicles[0].bodyType}}
            </span>
                        </div>
                    </div>
                </div>
                <div class="vehicle-section col-6">
                    <div class="vehicle-info-row row col-12">
                        <div class="col-6 p-0 m-0">
                            <ngx-qrcode [value]="inspectionData.vinNo" [elementType]="elementType" [errorCorrectionLevel]="correctionLevel" [cssClass]="'qrcode'" [width]="150"></ngx-qrcode>
                        </div>
                        <div class="col-6">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row col-12">
                <div class="banner-section col-6">
                    <div class="vehicle-info-row row col-12">
                        <div class="col-6 info-col exterior-color">

                        </div>
                        <div class="col-6 info-col interior-color">

                        </div>
                    </div>
                </div>
                <div class="vehicle-section col-6">
                    <div class="vehicle-info-row row col-12" [ngClass]="{'hide' : v3Report}">
                        <div class="col-6 info-col exterior-color">
                            <div class="info-label info-icon">Exterior Color</div>
                            <div class="info-val">
                                <!--div class="info-val-item" *ngFor="let exterior of resultData.exteriorColors; let i = index">
                                    <span>{{exterior.description}}</span>{{exterior.colorCode}}
                                    <span *ngIf="resultData.exteriorColors.length != i+1">,&nbsp;</span>
                                </div-->
                                <div class="info-val-item">
                                    <span>{{resultData.exteriorColors[0].description}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 info-col interior-color">
                            <div class="info-label info-icon">Interior Color</div>
                            <div class="info-val">
                                <div class="info-val-item">
                                    <span>{{resultData.interiorColors[0].description}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section-divider-gap"></div>
        <div class="detail-section">
            <div class="detail-info inspection-survey">
                <h3 class="h3-bgclass detail-head survey-icon">Section 2: Vehicle Survey
                </h3>
                <div class="detail-content" *ngIf="!isEditReport && !v3Report">
                    <div class="survey-data" *ngFor="let survey of surveyData">
                        <div class="survey-col col-left">{{survey.name}}</div>
                        <div class="survey-col col-right text-center"
                             [ngClass]="{'success': survey.status == 1, 'failure': survey.status == 0 || survey.status == 2}">
                            <span *ngIf="survey.status == 1"><i class="pi pi-check"></i>YES</span>
                            <span *ngIf="survey.status == 2 || survey.status == 0"><i class="pi pi-times"></i>NO</span>
                        </div>
                    </div>
                </div>
                <div class="detail-content row" *ngIf="!isEditReport && v3Report">
                    <div class="col-md-6 mb-3" *ngFor="let survey of surveyData; let s = index;" >
                        <div class="survey-data v3 d-flex justify-content-between align-items-center border rounded">
                            <div class="survey-col col-left"
                                 [class.truncate]="!survey.expanded"
                                 (click)="survey.expanded = !survey.expanded">
                                {{survey.name}}
                            </div>
                            <div class="survey-col col-right text-center"
                                 [ngClass]="{'success': survey.status == 1, 'failure': survey.status == 0 || survey.status == 2}">
                                <span *ngIf="survey.status == 1"><i class="pi pi-check"></i> YES</span>
                                <span *ngIf="survey.status == 2 || survey.status == 0"><i class="pi pi-times"></i> NO</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="detail-content" *ngIf="isEditReport">
                    <div class="survey-data" *ngFor="let survey of surveyData">
                        <div class="survey-col col-left">{{survey.name}}</div>
                        <div class="survey-col col-right text-center p-0 m-0">
                            <div class="row col-12 p-0 m-0">
                                <div class="col-6 pt-3 border-left link-cursor" [ngClass]="{'success': survey.status == 1}" (click)="onSurveyChange(survey, 1)">
                                    <span><i class="pi pi-check"></i>YES</span>
                                </div>
                                <div class="col-6 pt-3 border-left link-cursor" [ngClass]="{'failure': survey.status == 2}" (click)="onSurveyChange(survey, 2)">
                                    <span><i class="pi pi-times"></i>NO</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section-divider-gap"></div>
            <div class="detail-info damage-info">
                <h3 class="h3-bgclass detail-head damaged-car-icon">Section 3: Damage Area
                </h3>
                <div class="detail-content row justify-content-center">
                    <div class="demo-car col-12" *ngIf="!isEditReport">
                        <div *ngFor="let position of damagePositions" class="position position-{{position.id}}"
                             [ngClass]="{'active': position.damageFlag}">
                            <span class="position-item">{{position.id}}</span>
                            <span *ngIf="position.attachmentCount > 0" class="attach-count">{{position.attachmentCount}}</span>
                        </div>
                    </div>
                    <div class="demo-car col-12" *ngIf="isEditReport">
                        <div *ngFor="let position of damagePositions" class="position link-cursor position-{{position.id}}"
                             [ngClass]="{'active': position.damageFlag}">
                            <span class="position-item" (click)="markAsDamaged(position)">{{position.id}}</span>
                            <span *ngIf="position.damageFlag" class=" link-cursor attach-count" (click)="attachmentPopup(position)">{{position.attachmentCount || ''}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section-divider-gap"></div>
            <div class="detail-info damage-info pb-0">
                <h3 class="h3-bgclass detail-head gallery-icon">Section 4: Picture of Damaged Area</h3>
            </div>

            <div class="nothingtoshow row col-12 text-center" *ngIf="!isEditReport && attachments?.length ==0">
                <div class="col-3"></div>
                <div class="no-data-contaier col-6 border">
                    <div>
                        <img class="no-data-img-chart" src="../../../../assets/images/adas/report-icons/no-damage-area-picture.svg">
                    </div>
                    <div class="no-data-text p-3">Nothing to show</div>
                </div>
                <div class="col-3"></div>
            </div>
            <div *ngIf="isEditReport">
                <div class="detail-info attachments pl-2" *ngIf="loadingMediaFile || postUpload">
                    Uploading please wait
                    <div class="loader-dots"></div>
                    <app-file-attachment *ngIf="postUpload" class="attachment-file hide" [action]="manageAction"
                                         [apiData]="postApiData" (uploadedItems)="attachments($event)"
                                         (uploadComplete)="uploadComplete($event)"
                                         (roUploadComplete)="uploadComplete($event)"></app-file-attachment>
                </div>
                <div class="detail-info attachments pl-2" *ngFor="let damageAttachments of damagePositions"
                     [ngClass]="{'hide': (damageAttachments.attachmentCount == 0) || loadingMediaFile}">
                    <div *ngIf="damageAttachments.damageFlag" class="atachment-item">
                        <h3>Position: {{getLocationName(damageAttachments.id)}} ({{damageAttachments.id}})</h3>
                        <div class="attachment-section">
                            <div class="content attachment-cont assets-list">
                                <app-attachment-view [dynamicGid]="damageAttachments.id" [access]="fileAccess" [action]="fileAction"
                                                     [hideLabel]="hideLabel"
                                                     [attachments]="damageAttachments.attachments" *ngIf="!loadingMediaFile"></app-attachment-view>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!isEditReport">
                <div class="detail-info attachments" *ngFor="let damageAttachments of damagePositions"
                     [ngClass]="{'hide': damageAttachments.attachmentCount == 0}">
                    <div *ngIf="damageAttachments.damageFlag" class="atachment-item">
                        <h3>Position: {{getLocationName(damageAttachments.id)}} ({{damageAttachments.id}})</h3>
                        <div class="attachment-section">
                            <div class="content attachment-cont assets-list">
                                <app-attachment-view [dynamicGid]="damageAttachments.id" [access]="fileAccess" [action]="fileAction"
                                                     [hideLabel]="hideLabel"
                                                     [attachments]="damageAttachments.attachments"></app-attachment-view>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div *ngIf="notes != ''" class="detail-info notes">
                <div class="notes-head">Notes:</div>
                <div class="notes-info" [innerHTML]="notes"></div>
            </div>

            <div class="section-divider-gap"></div>
            <div class="detail-info adas-system pt-4">
                <h3 class="h3-bgclass detail-head target-icon">Section 5: Required Operations
                </h3>
            </div>

            <div class="detail-info adas-system pt-0 pb-0">
                <div class="detail-content">
                    <div class="row m-0"
                         [ngClass]="{'hide': !objectKeys(allDataDetails)?.length && !ruleEngines?.SAFETY?.length && !ruleEngines?.SCAN?.length && !ruleEngines?.STEERING?.length}">
                        <div class="col-3" [ngClass]="{'hide': !loadingRuleEngineActions}">
            <span class="row m-0 adas-operations-count-block">
                <img src="assets/images/landing-page/loading-more.svg"
                     alt="Loader"/>
            </span>
                        </div>
                        <div class="col-3 pl-0" [ngClass]="{'hide': !objectKeys(allDataDetails)?.length && !allDataTokenExpired}">
              <span class="row m-0 adas-operations-count-block">
                <span class="col systems-icon systems-bg-adas">
                  <span class="count">
                    <img src="assets/images/adas/report-icons/calpro-adas.svg" alt=""/>
                  </span>
                </span>
                <span class="details-block">
                  <span class="count count-bg-adas" *ngIf="objectKeys(allDataDetails)?.length">{{objectKeys(allDataDetails)?.length || 0}}</span>
                  <span class="count count-bg-adas text-small-c" *ngIf="!objectKeys(allDataDetails)?.length && allDataTokenExpired">Login to ALLDATA</span>
                  <span
                          class="text">ADAS {{objectKeys(allDataDetails)?.length > 1 ? 'Operations' : 'Operation'}} </span>
                </span>
              </span>
                        </div>
                        <div class="col-3 pl-0" [ngClass]="{'hide': !additionalSystemInfo?.length}">
            <span class="row m-0 adas-operations-count-block">
              <span class="col systems-icon systems-bg-adas-additional">
                <span class="count">
                  <img src="assets/images/adas/report-icons/calpro-adas.svg" alt=""/>
                </span>
              </span>
              <span class="details-block">
                <span class="count count-bg-safety">{{additionalSystemInfo?.length || 0}}</span>
                <span class="text">Additional ADAS {{additionalSystemInfo?.length > 1 ? 'Operations' : 'Operation'}}</span>
              </span>
            </span>
                        </div>
                        <div class="col-3 pl-0" [ngClass]="{'hide': !ruleEngines?.SAFETY?.length}">
            <span class="row m-0 adas-operations-count-block">
              <span class="col systems-icon  systems-bg-safety">
                <span class="count">
                  <img src="assets/images/adas/report-icons/calpro-safety.svg" alt=""/>
                </span>
              </span>
              <span class="details-block">
                <span class="count count-bg-safety">{{ruleEngines?.SAFETY?.length || 0}}</span>
                <span class="text">Safety {{ruleEngines?.SAFETY?.length > 1 ? 'Operations' : 'Operation'}}</span>
              </span>
            </span>
                        </div>
                        <div class="col-3 pl-0" [ngClass]="{'hide': !ruleEngines?.STEERING?.length}">
            <span class="row m-0 adas-operations-count-block">
              <span class="col systems-icon  systems-bg-steering">
                <span class="count">
                  <img src="assets/images/adas/report-icons/calpro-steering.svg" alt=""/>
                </span>
              </span>
              <span class="details-block">
                <span class="count count-bg-steering">{{ruleEngines?.STEERING?.length || 0}}</span>
                <span
                        class="text">Steering {{ruleEngines?.STEERING?.length > 1 ? 'Operations' : 'Operation'}}</span>
              </span>
            </span>
                        </div>
                        <div class="col-3 pl-0" [ngClass]="{'hide': !ruleEngines?.SCAN?.length}">
            <span class="row m-0 adas-operations-count-block">
              <span class="col systems-icon  systems-bg-scan">
                <span class="count">
                  <img src="assets/images/adas/report-icons/calpro-scan.svg" alt=""/>
                </span>
              </span>
              <span class="details-block">
                <span class="count count-bg-scan">{{ruleEngines?.SCAN?.length || 0}}</span>
                <span class="text">SCAN {{ruleEngines?.SCAN?.length > 1 ? 'Operations' : 'Operation'}}</span>
              </span>
            </span>
                        </div>
                    </div>
                </div>
            </div>
            <hr [ngClass]="{'hide': !objectKeys(allDataDetails)?.length && !ruleEngines?.SAFETY?.length && !ruleEngines?.SCAN?.length && !ruleEngines?.STEERING?.length}"/>
            <div class="detail-info adas-system">
                <div>
                    <div class="detail-content pt-3">
                        <div class="row col-12 pb-2">
            <span class="row m-0 adas-operations-count-block p-0 border-0">
              <span class="col systems-icon systems-bg-adas">
                <span class="count">
                  <img src="assets/images/adas/report-icons/calpro-adas.svg" alt=""/>
                </span>
              </span>
              <span class="details-block">
                <span class="text-heading m-0 pt-2">
                  ADAS, POST-Repair Calibration/Initialization {{objectKeys(allDataDetails)?.length ? '(' + objectKeys(allDataDetails)?.length + ')' : ''}}
                </span>
              </span>
            </span>
                        </div>
                        <p-accordion class="report-section report-section-updated custom-accordion flat-custom-accordion thread-detail-accordion hide" *ngIf="!v3Report">
                            <p-accordionTab id="section-systems-impacted" class="section" [transitionOptions]="'100ms'"
                                            [selected]="true">
                                <p-header class="sec-info">
                                    <div class="sec-title">
                                    <span class="sec-head truncate" title="ADAS System Impacted (May vary by vehicle model or trim level)">ADAS System Impacted (May vary by vehicle model or trim level)</span>
                                    </div>
                                </p-header>
                                <div class="content-list" id="cont-list-systems-impacted" *ngIf="!v3Report">
                                    <div *ngIf="!objectKeys(adasSystems)?.length">
                                        <div class="row m-0">
                                            <div class="col-12 adas-system-header pl-5">
                                                No systems impacted
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="objectKeys(adasSystems)?.length">
                                        <div class="row m-0">
                                            <div class="col-4 adas-system-header pl-5">ADAS System</div>
                                            <div class="col-4 adas-system-header pl-5">Sub Category</div>
                                            <div class="col-4 adas-system-header pl-5">Branded Feature Name</div>
                                        </div>
                                    </div>
                                    <div *ngFor="let categoryName of objectKeys(adasSystems)">
                                        <div class="row adas-system-category-block">
                                            <div class="col-4 pl-5">{{categoryName}}</div>
                                            <div class="col-4 pl-5"></div>
                                            <div class="col-4 pl-5"></div>
                                        </div>
                                        <div class="row adas-system-sub-category-block"
                                             *ngFor="let item of adasSystems[categoryName]; let s = index;"
                                             [ngClass]="{'hide': item.categoryName == ''}">
                                            <div class="col-4 pl-5"></div>
                                            <div class="col-4 pl-5">{{v3Report ? item.name : item.subCategoryName}}</div>
                                            <div class="col-4 pl-5">{{v3Report ? item.nameNoBrand : item.brandedFeatureName}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="content-list" id="cont-list-systems-impacted" *ngIf="v3Report">
                                    <div *ngIf="!objectKeys(adasSystems)?.length">
                                        <div class="row m-0">
                                            <div class="col-12 adas-system-header pl-5">
                                                No systems impacted
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="objectKeys(adasSystems)?.length">
                                        <div class="row m-0">
                                            <div class="col-4 adas-system-header pl-5">ADAS System</div>
                                            <div class="col-4 adas-system-header pl-5">Branded Feature Name</div>
                                        </div>
                                    </div>
                                    <div *ngFor="let categoryName of objectKeys(adasSystems)">
                                        <div class="row adas-system-category-block">
                                            <div class="col-4 pl-5">{{categoryName}}</div>
                                            <div class="col-4 pl-5"></div>
                                        </div>
                                        <div class="row adas-system-sub-category-block"
                                             *ngFor="let item of adasSystems[categoryName]; let s = index;"
                                             [ngClass]="{'hide': item.categoryName == ''}">
                                            <div class="col-4 pl-5"></div>
                                            <div class="col-4 pl-5">{{v3Report ? item.nameNoBrand : item.brandedFeatureName}}</div>
                                        </div>
                                    </div>
                                </div>

                            </p-accordionTab>
                        </p-accordion>
                        <p-accordion class="report-section report-section-updated custom-accordion flat-custom-accordion thread-detail-accordion adas-report-accordion"
                                *ngIf="(enableAllData || enableSunCollision) && !v3Report">
                            <p-accordionTab id="section-prci" class="section" [transitionOptions]="'100ms'" [selected]="true">
                                <p-header class="sec-info">
                                    <div class="sec-title">
                                        <span class="sec-head truncate" title="ADAS operations to be performed: Post-Repair Calibration/Initialization">ADAS operations to be performed: Post-Repair Calibration/Initialization</span>
                                    </div>
                                </p-header>
                                <div class="content-list" id="cont-list-prci">
                                    <div *ngIf="enableSunCollision" class="col-12 procedure-links pt-3 pb-3">
                                        <button class="btn btn-primary" (click)="openSunCollisionLink()">View on Sun Collision</button>
                                    </div>
                                    <div *ngIf="enableAllData" class="row m-0">
                                        <div class="col-12 mt-3 procedure-links" *ngFor="let link of allDataDetails; let s = index;"
                                             [ngClass]="{'border-0': s == (allDataDetails?.length -1) , 'hide': !allDataDetails?.length}">
                                            <div class="module-header d-block">
                                                {{s + 1}}. {{link.title}}
                                                <span class="float-right row">
                                                  <button class="btn add-btn p-1" (click)="removeAllDataLink(link)" *ngIf="isEditReport">
                                                    <i style="margin-right: 5px; font-size: 14px;" class="pi pi-trash"></i>&nbsp;&nbsp;Remove
                                                  </button>
                                                    <!-- toggle -->
                                                    <span class="cursor toggle-box togglebox row col-6 p-0 m-0 hide" style="width: 200px;" (click)="$event.stopPropagation()">
                                                        <span class="col-6 toggle-col field-label p-0 m-0 b"><strong>Equipped</strong></span>
                                                        <span class="col-6 toggle-col toggle-option  p-0 m-0">
                                                            <p-inputSwitch (click)="$event.stopPropagation()" [(ngModel)]="link.equipped" (onChange)="updateIsEquipped(link ,$event)">
                                                            </p-inputSwitch>
                                                        </span>
                                                    </span>
                                                    <!-- toggle -->
                                                    <!-- toggle -->
                                                    <span class="cursor toggle-box togglebox row col-6 p-0 m-0" style="width: 100px;" (click)="$event.stopPropagation()">
                                                        <span class="col-4 toggle-col field-label p-0 m-0 b"><strong>Show</strong></span>
                                                        <span class="col-4 toggle-col toggle-option p-0 m-0">
                                                            <p-inputSwitch (click)="$event.stopPropagation()" [(ngModel)]="link.show" (onChange)="updateShow(link ,$event)">
                                                            </p-inputSwitch>
                                                        </span>
                                                    </span>
                                                    <!-- toggle -->
                                                </span>

                                            </div>
                                            <div class="row col-12">
                                                {{link.allDataName}}
                                            </div>
                                            <div class="module-content">
                                                <div class="row col-12" *ngIf="link.repairLocation">
                                                    <div class="col-6 p-0">
                                                        <h6>Repair Location: <span class="text-dark text-bold">&nbsp;&nbsp;{{link.repairLocation ? link.repairLocation : '#'}}</span>
                                                        </h6>
                                                    </div>
                                                    <div class="row col-9">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="module-content">
                                                <div class="row col-12" *ngIf="link.estimate_line_no">
                                                    <div class="col-6 p-0">
                                                        <h6 [innerHTML]="link.estimate_line_no"></h6>
                                                    </div>
                                                    <div class="row col-9">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="module-content">
                                                <div class="col-3 p-0">
                                                    <h6>Reference Links</h6>
                                                    <ul class="link-list">
                                                        <li *ngFor="let sub_link of link?.referenceLinks" class="mb-2">
                                                            <img src="assets/images/adas/report-icons/adas-report-link-icon.svg"
                                                                 alt="{{sub_link?.title}}"/>
                                                            <a href="{{sub_link?.href}}" class="link" target="_blank"> {{sub_link?.title}}</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="col-12 p-0"
                                                     [ngClass]="{'hide': link.requiredItems?.length || link.typeItems?.length || link.toolsItems?.length}">
                                                    <h6>Calibration Not Required</h6>
                                                </div>
                                                <div class="col-3"
                                                     [ngClass]="{'hide': !link.requiredItems?.length && !link.typeItems?.length && !link.toolsItems?.length}">
                                                    <h6>Required</h6>
                                                    <div class="check-item mb-2" *ngFor="let text of link.requiredItems">
                                                        <i class="fa-regular fa-circle-check check-icon"></i>
                                                        <span [innerHTML]="text"></span>
                                                    </div>
                                                    <span *ngIf="!link?.requiredItems?.length"> - </span>
                                                </div>
                                                <div class="col-3"
                                                     [ngClass]="{'hide': !link.requiredItems?.length && !link.typeItems?.length && !link.toolsItems?.length}">
                                                    <h6>Type</h6>
                                                    <div class="check-item mb-2" *ngFor="let text of link.typeItems">
                                                        <i class="fa-regular fa-circle-check check-icon"></i>
                                                        <span [innerHTML]="text"></span>
                                                    </div>
                                                    <span *ngIf="!link?.typeItems?.length"> - </span>
                                                </div>
                                                <div class="col-3"
                                                     [ngClass]="{'hide': !link.requiredItems?.length && !link.typeItems?.length && !link.toolsItems?.length}">
                                                    <h6>Essentials & Special Tools</h6>
                                                    <div class="check-item mb-2" *ngFor="let text of link.toolsItems">
                                                        <i class="fa-regular fa-circle-check check-icon"></i>
                                                        <span [innerHTML]="text"></span>
                                                    </div>
                                                    <span *ngIf="!link?.toolsItems?.length"> - </span>
                                                </div>
                                            </div>
                                            <div class="module-content" [ngClass]="{'hide': !link?.notes}">
                                                <div class="row col-12 p-0 pl-3 pb-4">
                                                    <div class="col-3">
                                                    </div>
                                                    <div class="col-9">
                                                        <span *ngIf="link?.notes">Notes: </span>&nbsp;<span [innerHTML]="link?.notes"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="module-content" [ngClass]="{'hide': !link?.systems}">
                                                <div class="row col-12 p-0 pl-3 pb-1">
                                                    <div class="col-6 p-0">
                                                        <div class="module-header">
                                                            Used in following ADAS systems
                                                        </div>
                                                    </div>
                                                    <div class="col-6">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="module-content">
                                                <div class="row col-12 p-0 pl-3 pb-4">
                                                    <div class="col-12 p-0 used-in-systems">
                                                        <span *ngIf="link?.systems"><span [innerHTML]="link?.systems"></span></span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row m-1 mb-3 border rounded-10" *ngFor="let adasItem of link?.positionStatements">
                                                <div class="col-md-9 border p-3">
                                                    <span [innerHTML]="adasItem?.text || adasItem?.oem_documentation_title"></span>
                                                </div>
                                                <div class="col-md-3 border p-3">
                                                      <span *ngIf="adasItem?.oem_documentation_link && adasItem?.oem_documentation_link != '#'">
                                                        <a target="_blank" href="{{adasItem?.oem_documentation_link}}">{{adasItem?.oem_documentation_title || 'View Procedure'}}</a>
                                                      </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row m-0" *ngIf="!allDataDetails?.length && !allDataTokenExpired">
                                            <div class="col-12 adas-system-header pl-5">
                                                {{ allDataResponseMsg || 'No reference links found from ALLDATA'}}
                                            </div>
                                        </div>
                                        <div *ngIf="allDataTokenExpired" class=" pl-5">
                                            <button class="btn btn-primary" (click)="syncAllDataAccessToken()">
                                                Login to ALLDATA
                                            </button>
                                        </div>
                                    </div>

                                </div>

                            </p-accordionTab>
                        </p-accordion>
                        <br/>
                        <br/>
                        <span *ngIf="v3Report">
                            <p-accordion class="report-section report-section-updated custom-accordion flat-custom-accordion thread-detail-accordion mt-3" *ngFor="let link of allDataDetails; let s = index;">
                            <p-accordionTab class="section" [transitionOptions]="'100ms'" [selected]="true">
                                <p-header class="sec-info">
                                    <div class="sec-title">
                                        <div class="row pt-2">
                                            <div class="col-4">
                                                <span class="sec-head truncate" title="">Calibrate: {{link.calibrate ? link.calibrate : '-'}}</span>
                                            </div>
                                            <div class="col-4">
                                                <span class="sec-head truncate" title=""><span style=" font-style: normal;  line-height: normal;  letter-spacing: normal;font-weight: normal;color: #444;">Calibration Type: </span>{{link.calibrationType ? link.calibrationType : '-'}}</span>
                                            </div>
                                            <div class="col-4 row">
                                                <!-- toggle -->
                                                <span class="cursor toggle-box togglebox row col-4 p-0 m-0">
                                                </span>
                                                <!-- toggle -->
                                                <!-- toggle -->
                                                <span class="cursor toggle-box togglebox row col-4 p-0 m-0 hide" style="width: 200px;" (click)="$event.stopPropagation()">
                                                        <span class="col-6 toggle-col field-label p-0 pt-1 m-0 b"><strong>Equipped</strong></span>
                                                        <span class="col-6 toggle-col toggle-option  p-0 m-0">
                                                            <p-inputSwitch (click)="$event.stopPropagation()" [(ngModel)]="link.equipped" (onChange)="updateIsEquipped(link ,$event)">
                                                            </p-inputSwitch>
                                                        </span>
                                                </span>
                                                <!-- toggle -->
                                                <!-- toggle -->
                                                <span class="cursor toggle-box togglebox row col-4 p-0 m-0" style="width: 100px;" (click)="$event.stopPropagation()">
                                                        <span class="col-4 toggle-col field-label p-0 pt-1 m-0 b"><strong>Show</strong></span>
                                                        <span class="col-4 toggle-col toggle-option p-0 m-0">
                                                            <p-inputSwitch (click)="$event.stopPropagation()" [(ngModel)]="link.show" (onChange)="updateShow(link ,$event)">
                                                            </p-inputSwitch>
                                                        </span>
                                                </span>
                                                <!-- toggle -->
                                            </div>
                                        </div>
                                    </div>
                                </p-header>
                                <div class="content-list"
                                     [ngClass]="{'border-0': s == (allDataDetails?.length -1) , 'hide': !allDataDetails?.length}">
                                    <div class="mb-3" style="border-bottom: 1px solid rgba(0, 0, 0, .1);">
                                        <div class="row col-12">
                                            <div class="col-6 p-0">
                                                <h6>Repair Location: <span class="text-dark text-bold">&nbsp;&nbsp;{{link.repairLocation ? link.repairLocation : '#'}}</span>
                                                </h6>
                                            </div>
                                            <div class="row col-9">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-3" style="border-bottom: 1px solid rgba(0, 0, 0, .1);">
                                        <div class="row col-12">
                                            <div class="col-6 p-0">
                                                <h6>Estimate Trigger: <span class="text-dark text-bold">&nbsp;&nbsp;{{link.estimateTrigger ? link.estimateTrigger : '-'}}</span>
                                                </h6>
                                            </div>
                                            <div class="row col-9">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-3" style="border-bottom: 1px solid rgba(0, 0, 0, .1);">
                                        <div class="row col-12" *ngFor="let feature of link?.featureObjects">
                                            <div class="col-12 p-0">
                                                <h6 class="row">
                                                    <div class="col-3">
                                                        Feature: <span class="text-dark text-bold">&nbsp;&nbsp;{{feature.featureName ? feature.featureName : '-'}}</span>
                                                    </div>
                                                    <div class="col-9">
                                                        OEM ADAS System Name:  <span class="text-dark text-bold">&nbsp;&nbsp;{{feature.oemAdasSystemName ? feature.oemAdasSystemName : '-'}}</span>
                                                    </div>
                                                </h6>
                                            </div>
                                            <div class="row col-9">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-3" style="border-bottom: 1px solid rgba(0, 0, 0, .1);">
                                        <div class="row col-12">
                                            <div class="col-6 p-0">
                                                <h6>Calibration Prerequisites:
                                                </h6>
                                            </div>
                                            <div class="row col-12">
                                                <ul class="link-list">
                                                    <li *ngFor="let text of link?.calibrationPreRequisites" class="mb-2">
                                                        <img src="assets/images/adas/report-icons/adas-report-info-icon.png"
                                                             alt="Calibration PreRequisites"/>
                                                        <span class="pl-2" style="font-weight: 500;" [innerHTML]="text"></span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-1 hide" style="border-bottom: 1px solid rgba(0, 0, 0, .1);" *ngIf="link.referenceLinks && this.domainId == '346'">
                                        <div class="row col-12">
                                            <div class="col-6 p-0 mb-3">
                                                <h6>
                                                  AI Reasoning: <button class="btn add-btn report-action-btn mr-1 mt-1 p-1" (click)="getAIResponses(link)">
                                                  <span class="pi pi-refresh" style="color: green;"></span>
                                                </button>
                                                  <button class="btn add-btn report-action-btn mr-1 mt-1 p-1" (click)="getAIResponses(link,true)">
                                                    <span class="pi pi-search" style="color: green;"></span>
                                                  </button>
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-1" style="border-bottom: 1px solid rgba(0, 0, 0, .1);" *ngIf="this.loadingAiResponses[link?.id] || aiResponses[link?.id]">
                                                <div class="row col-12 text-center mb-1" *ngIf="this.loadingAiResponses[link?.id]" >
                                                    <div class="loader-dots"></div>
                                                </div>
                                            <div class="row col-12" *ngIf="!this.loadingAiResponses[link?.id]">
                                              <p [innerHTML]="aiResponses[link?.id]" *ngIf="aiResponses[link?.id]"></p>
                                            </div>
                                    </div>
                                    <div class="mb-3" style="border-bottom: 1px solid rgba(0, 0, 0, .1);">
                                        <div class="row col-12" *ngIf="link.referenceLinks && link?.referenceLinks?.length">
                                            <div class="col-6 p-0">
                                                <h6>Reference Links
                                                </h6>
                                            </div>
                                            <div class="row col-12">
                                                <div class="col-12 adas-system-header pl-5" *ngIf="!link?.referenceLinks?.length">
                                                    {{'No reference links found from ALLDATA'}}
                                                </div>
                                                <span *ngFor="let sub_link of link?.referenceLinks" class="col-3 p-2">
                                                    <img src="assets/images/adas/report-icons/adas-report-link-icon.svg"
                                                         alt="{{sub_link?.title}}"/>
                                                    <a href="{{sub_link?.href}}" class="link" target="_blank"> {{sub_link?.title}}</a>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-3">
                                            <div class="row m-1 border rounded-10" *ngFor="let adasItem of link?.positionStatements">
                                                <div class="col-md-9 border p-3">
                                                    <span [innerHTML]="adasItem?.text || adasItem?.oem_documentation_title"></span>
                                                </div>
                                                <div class="col-md-3 border p-3">
                                                      <span *ngIf="adasItem?.oem_documentation_link && adasItem?.oem_documentation_link != '#'">
                                                        <a target="_blank" href="{{adasItem?.oem_documentation_link}}">{{adasItem?.oem_documentation_title || 'View Procedure'}}</a>
                                                      </span>
                                                </div>
                                            </div>
                                    </div>
                                </div>

                                <div class="row m-0" *ngIf="!allDataDetails?.length && !allDataTokenExpired">
                                    <div class="col-12 adas-system-header pl-5">
                                        {{ allDataResponseMsg || 'No reference links found from ALLDATA'}}
                                    </div>
                                </div>
                                <div *ngIf="allDataTokenExpired" class=" pl-5">
                                    <button class="btn btn-primary" (click)="syncAllDataAccessToken()">
                                        Login to ALLDATA
                                    </button>
                                </div>
                            </p-accordionTab>
                        </p-accordion>
                            <div class="detail-info notes" *ngIf="!allDataDetails?.length || allDataTokenExpired">
                                <div *ngIf="!allDataDetails?.length" class="row m-0">
                                    <div class="col-12 adas-system-header pl-5">
                                        {{ allDataResponseMsg || 'No systems impacted'}}
                                    </div>
                                </div>
                            </div>
                        </span>
                    </div>
                </div>
                <div class="pt-3 pb-3" [ngClass]="{'hide': !additionalSystemInfo?.length || isEditReport}">
                    <div class="section-divider-gap"></div>
                    <div class="row col-12">
                        <span class="row m-0 adas-operations-count-block p-0 border-0">
                          <span class="col systems-icon systems-bg-adas-additional">
                            <span class="count">
                              <img src="assets/images/adas/report-icons/calpro-adas.svg" alt=""/>
                            </span>
                          </span>
                          <span class="details-block">
                            <span class="text-heading m-0 pt-2">ADAS Additional {{additionalSystemInfo?.length > 1 ? 'Operations' : 'Operation'}}
                                ({{additionalSystemInfo?.length || 0}})</span>
                          </span>
                        </span>
                    </div>
                    <div class="detail-content mt-4 border pl-0 pr-0">
                        <div class="row m-1 mb-3 border-bottom rounded-10 pl-0 pr-0" *ngFor="let additionalSystemInfoItem of additionalSystemInfo"
                             [ngClass]="{'hide': !additionalSystemInfo?.length}">
                            <div class="col-md-12 p-3">
                                {{additionalSystemInfoItem?.name}}
                            </div>
                        </div>
                    </div>

                    <div class="detail-content mt-4 border pl-0 pr-0" *ngIf="isEditReport">

                        <div class="detail-info damage-info pb-0">
                            <h3 class="h3-bgclass detail-head pl-4">Additional</h3>
                        </div>
                        <div class="row mt-3">
                            <div class="col-12">
                                <button class="add-btn" (click)="addAdditional()">
                                    <i class="fa fa-plus"></i>
                                    Add Additional
                                </button>
                            </div>
                        </div>
                        <div *ngFor="let item of this.additionalSystemInfo">
                            <div class="row mt-3 additional_systems_item">
                                <div class="col-9">
                                    {{item?.name}}
                                </div>
                                <div class="col-3 float-right text-right">
                                    <button class="btn p-0" (click)="removeAdditional(item)" style="color: #999999 !important;">
                                        <i class="pi pi-times"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pt-3 pb-3" [ngClass]="{'hide': !isEditReport}">
                    <div class="section-divider-gap"></div>
                    <div class="row col-12">
            <span class="row col-10 m-0 adas-operations-count-block p-0 border-0">
              <span class="col systems-icon systems-bg-adas-additional">
                <span class="count">
                  <img src="assets/images/adas/report-icons/calpro-adas.svg" alt=""/>
                </span>
              </span>
              <span class="details-block">
                <span class="text-heading m-0 pt-2">ADAS Additional {{additionalSystemInfo?.length > 1 ? 'Operations' : 'Operation'}}
                    ({{additionalSystemInfo?.length || 0}})</span>
              </span>
            </span>
                        <span class="col-2 float-right pt-2 pl-3">
                <button class="add-btn float-right" (click)="addAdditional()">
                  <i class="fa fa-plus"></i>
                  Add Additional
                </button>
          </span>
                    </div>

                    <div class="detail-content mt-4 border pl-0 pr-0">
                        <div *ngFor="let item of this.additionalSystemInfo">
                            <div class="row m-0 mt-3 additional_systems_item">
                                <div class="col-9">
                                    {{item?.name}}
                                </div>
                                <div class="col-3 float-right text-right">
                                    <button class="btn p-0" (click)="removeAdditional(item)" style="color: #999999 !important;">
                                        <i class="pi pi-times"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="pt-3 pb-3" [ngClass]="{'hide': !ruleEngines?.SCAN?.length}">
                    <div class="section-divider-gap"></div>
                    <div class="row col-12">
                        <span class="row m-0 adas-operations-count-block p-0 border-0">
                            <span class="col systems-icon systems-bg-scan">
                                <span class="count">
                                    <img src="assets/images/adas/report-icons/calpro-scan.svg" alt=""/>
                                </span>
                            </span>
                            <span class="details-block">
                                <span class="text-heading m-0 pt-2">Scan {{ruleEngines?.SCAN?.length > 1 ? 'Operations' : 'Operation'}}
                                    ({{ruleEngines?.SCAN?.length || 0}})</span>
                            </span>
                        </span>
                    </div>
                    <div class="detail-content mt-4">
                        <div class="row m-1 mb-3 border rounded-10" *ngFor="let scanItem of ruleEngines?.SCAN"
                             [ngClass]="{'hide': !ruleEngines?.SCAN?.length}">
                            <div class="col-md-3 border p-3">
                                <span [innerHTML]="scanItem?.procedure"></span>
                            </div>
                            <div class="col-md-6 border p-3">
                                <span [innerHTML]="scanItem?.text"></span>
                            </div>
                            <div class="col-md-3 border p-3">
                                <span *ngIf="scanItem?.oem_documentation_link && scanItem?.oem_documentation_link != '#'">
                                    <a target="_blank" href="{{scanItem?.oem_documentation_link}}">{{scanItem?.oem_documentation_title ? scanItem?.oem_documentation_title : 'View Procedure'}}</a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pt-3 pb-3" [ngClass]="{'hide': !ruleEngines?.SAFETY?.length}">
                    <div class="section-divider-gap"></div>
                    <div class="row col-12 pb-2">
                        <span class="row m-0 adas-operations-count-block p-0 border-0">
                            <span class="col systems-icon systems-bg-safety">
                                <span class="count">
                                    <img src="assets/images/adas/report-icons/calpro-safety.svg" alt=""/>
                                </span>
                            </span>
                            <span class="details-block">
                                <span class="text-heading m-0 pt-2">Safety {{ruleEngines?.SAFETY?.length > 1 ? 'Operations' : 'Operation'}}
                                    ({{ruleEngines?.SAFETY?.length || 0}})
                                </span>
                            </span>
                        </span>
                    </div>
                </div>
                <div class="detail-content mt-4">
                    <div class="row m-1 mb-3 border rounded-10" *ngFor="let safetyItem of ruleEngines?.SAFETY">
                        <div class="col-md-3 border p-3">
                            <span [innerHTML]="safetyItem?.procedure"></span>
                        </div>
                        <div class="col-md-6 border p-3">
                            <span [innerHTML]="safetyItem?.text"></span>
                        </div>
                        <div class="col-md-3 border p-3">
                          <span *ngIf="safetyItem?.oem_documentation_link && safetyItem?.oem_documentation_link != '#'">
                            <a target="_blank" href="{{safetyItem?.oem_documentation_link}}">{{safetyItem?.oem_documentation_title ? safetyItem?.oem_documentation_title : 'View Procedure'}}</a>
                          </span>
                        </div>
                    </div>
                </div>
                <div class="pt-3 pb-3" [ngClass]="{'hide': !ruleEngines?.STEERING?.length}">
                    <div class="section-divider-gap"></div>
                    <div class="row col-12 pb-2">
            <span class="row m-0 adas-operations-count-block p-0 border-0">
              <span class="col systems-icon systems-bg-steering">
                <span class="count">
                  <img src="assets/images/adas/report-icons/calpro-steering.svg" alt=""/>
                </span>
              </span>
              <span class="details-block">
                <span
                        class="text-heading m-0 pt-2">Steering {{ruleEngines?.STEERING?.length > 1 ? 'Operations' : 'Operation'}}
                    ({{ruleEngines?.STEERING?.length || 0}})</span>
              </span>
            </span>
                    </div>
                    <div class="detail-content mt-4">
                        <div class="row m-1 mb-3 border rounded-10" *ngFor="let steerA of ruleEngines?.STEERING">
                            <div class="col-md-3 border p-3">
                                <span [innerHTML]="steerA?.procedure"></span>
                            </div>
                            <div class="col-md-6 border p-3">
                                <span [innerHTML]="steerA?.text"></span>
                            </div>
                            <div class="col-md-3 border p-3">
                <span *ngIf="steerA?.oem_documentation_link && steerA?.oem_documentation_link != '#'">
                  <a target="_blank" href="{{steerA?.oem_documentation_link}}">{{steerA?.oem_documentation_title ? steerA?.oem_documentation_title : 'View Procedure'}}</a>
                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div [ngClass]="{'hide': !positionStatements?.length}">
                    <div class="section-divider-gap"></div>
                    <h3 class="h3-bgclass detail-head position-statements-info-icon">Section 6: Position statements
                    </h3>
                    <div class="detail-content">
                        <div class="row m-1 mb-3 pt-3 pb-3 border rounded-10">
                            <div class="row col-12 m-1" *ngFor="let row of chunkArray(positionStatements, 4)">
                                <div class="col-md-3" *ngFor="let item of row">
                                    <a href="{{ item.link }}" class="d-block text-decoration-none text-primary" target="_blank">
                                        <img src="assets/images/adas/report-icons/adas-report-link-icon.svg"
                                             alt="{{ item.title }}"/> {{ item.title }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section-divider-gap"></div>
                <div class="row m-1 mb-3 row-divider">
                    <div class="col-12 p-0">This report utilizes the <a target="_blank"
                                                                        href="https://patents.google.com/patent/US11210869B2/en?oq=11%2c210%2c869">Patent
                        USPTO 11,210,869</a> (Vehicle safety feature identification
                        and calibration)
                    </div>
                </div>
                <div class="section-divider-gap"></div>
                <div class="row m-1 mt-3 mb-3 p-3 border rounded-10">
                    <div class="col-12 font-weight-bold">Disclaimer</div>
                    <div class="col-12 p-3">
                        This report includes information from third parties, such as OEM build information and OEM Service Information
                        (the “Third Party Content”). The Third Party Content provided to you is obtained from sources believed to be
                        reliable; however, no guarantees are made by CalPro or Collabtic or the providers of the Third Party Content
                        as
                        to its accuracy or completeness. CalPro and Collabtic combine this Third Party Content with the data you have
                        provided to produce this report, which is intended as a guide for the repair process and does not constitute a
                        definitive statement of vehicle systems or required calibrations. Any errors in Third Party Content, or in the
                        data you provide to us, may result in inaccuracies in this report. This report is provided for information
                        purposes only, not as a substitute for your own research or the exercise of your professional judgment. You
                        should always reference OEM recommendations and procedures, specifically those related to Advanced Driver
                        Assistance Systems (ADAS) repair and calibration, in order to determine the appropriate actions required given
                        the circumstances at hand.
                    </div>
                </div>
                <!-- System Information -->
                <div class="reference-info hide">
                    <mat-accordion [multi]="true" #accordion="matAccordion">
                        <mat-expansion-panel class="{{panel.class}}"
                                             [disabled]="panel.isDisabled"
                                             [expanded]="panel.isExpanded"
                                             [hideToggle]="false"
                                             (opened)="beforeParentPanelOpened(panel, emptyList)"
                                             (closed)="beforeParentPanelClosed(panel, emptyList)"
                                             (afterCollapse)="afterPanelClosed()"
                                             (afterExpand)="afterPanelOpened()"
                                             *ngFor="let panel of referenceAccordion"
                                             #mapanel="matExpansionPanel">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <b>{{panel.title}}</b>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="app-accord">
                                <app-system-info-view [systemInfo]="systemInfo"></app-system-info-view>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
                <div class="section-divider-gap"></div>
                <div class="report-footer">
                    <div class="row col-12">
                        <div class="col-6 col-md-6 col-sm-12 footer-col">
                            <ul>
                                <li class="rf-li domain-name">{{businessData.domainName}}</li>
                                <li class="rf-li vin">VIN: {{inspectionData.vinNo}}</li>
                                <li class="rf-li ro-id">Report ID: {{roId > 0 ? inspectionData.id : reportId}}</li>
                            </ul>
                        </div>
                        <div class="col-6 col-md-6 col-sm-12 footer-col">
                            <div class="text-right">Report by CalPro on Collabtic platform.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <!--old design-->
    <div *ngIf="!emptyFlag && !loading && !isNewReport"
         class="d-flex justify-content-center align-items-center">
        <div id="calprosec">
            <div class="detail-section business-info row col-12">
                <div class="col-8 col-lg-8 col-md-6 col-sm-12 domain-info">
                    <div class="domain-logo" [ngStyle]="{'background-image': 'url(' + businessData.logo + ')'}"></div>
                    <div class="row-head">{{businessData.domainName}}</div>
                    <div *ngIf="businessData.address != ''" class="split-bg-row addr">{{businessData.address}}</div>
                    <!--div class="split-bg-row email">-</div-->
                    <div *ngIf="businessData.phone != ''" class="split-bg-row phone">{{businessData.phone}}</div>
                    <div class="empty-row"></div>
                    <div class="split-bg-row market">
                        <span class="split-col label">Market: </span>
                        <span class="split-col value">{{inspectionData.market != '' ? inspectionData.market : '-'}}</span>
                    </div>
                    <div class="split-bg-row sales-rep hide">
                        <span class="split-col label">Sales Person: </span>
                        <span class="split-col value">{{inspectionData.salesPerson != '' ? inspectionData.salesPerson : '-'}}</span>
                    </div>
                </div>
                <div class="col-4 col-lg-4 col-md-6 col-sm-12 report-info">
                    <div class="split-row report-id">
                        <span class="split-col label">Report ID: </span>
                        <span class="split-col value">{{inspectionData.id}}</span>
                    </div>
                    <div class="split-row report-date">
                        <span class="split-col label">Report Date: </span>
                        <span class="split-col value">{{inspectionData.createdOnDate}}</span>
                    </div>
                    <div *ngIf="roFlag">
                        <div class="split-row ro-id">
                            <span class="split-col label">RO ID: </span>
                            <span class="split-col value">{{inspectionData.workOrderId}}</span>
                        </div>
                        <div class="split-row ref-shop">
                            <span class="split-col label">Shop RO#: </span>
                            <span class="split-col value">{{roShopRef}}</span>
                        </div>
                    </div>
                    <div *ngIf="customerDataFlag">
                        <div class="empty-row"></div>
                        <div class="row-head">{{customerInfo.name}}</div>
                        <div class="split-bg-row addr">{{customerInfo.address}}</div>
                        <div class="split-bg-row email">{{customerInfo.email}}</div>
                        <div *ngIf="customerInfo.phone != ''" class="split-bg-row phone">{{customerInfo.phone}}</div>
                        <div *ngIf="contactDataFlag">
                            <div class="empty-row"></div>
                            <div class="row-head sub-head">Customer Contact</div>
                            <div class="split-bg-row user">{{contactInfo.firstName}} {{contactInfo.lastName}}</div>
                            <div class="split-bg-row email">{{contactInfo.email}}</div>
                            <div *ngIf="contactInfo.phoneNumber != ''" class="split-bg-row phone">{{contactInfo.phoneNumber}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="detail-row row-divider">
                <div class="row col-12">
                    <div class="banner-section col-6">
                        <div class="bs-col banner">
                            <div class="banner-image" [ngStyle]="{'background-image': 'url(' + logo + ')'}"></div>
                        </div>
                        <div class="bs-col vin-info">
                            <div class="vin-no">
                                VIN: {{inspectionData.vinNo}}
                                <span class="cursor copy" title="Copy Link" (click)="copyLink(inspectionData.vinNo);"></span>
                                <div *ngIf="copiedModal" class="copied-txt-div">
                                    <div class="copied-txt-inner-div">VIN Copied</div>
                                </div>
                            </div>
                            <div class="vinfo">
                                <span *ngIf="resultData.make">{{resultData.make}}</span>
                                <span *ngIf="resultData.model"><i class="pi pi-chevron-right"></i> {{resultData.model}}</span>
                                <span *ngIf="resultData.year"><i class="pi pi-chevron-right"></i> {{resultData.year}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="vehicle-section col-6">
                        <div class="vehicle-info-row row col-12" [ngClass]="{'hide' : v3Report}">
                            <div class="col-6 info-col exterior-color">
                                <div class="info-label info-icon">Exterior Color</div>
                                <div class="info-val">
                                    <!--div class="info-val-item" *ngFor="let exterior of resultData.exteriorColors; let i = index">
                                        <span>{{exterior.description}}</span>{{exterior.colorCode}}
                                        <span *ngIf="resultData.exteriorColors.length != i+1">,&nbsp;</span>
                                    </div-->
                                    <div class="info-val-item">
                                        <span>{{resultData.exteriorColors[0].description}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 info-col interior-color">
                                <div class="info-label info-icon">Interior Color</div>
                                <div class="info-val">
                                    <div class="info-val-item">
                                        <span>{{resultData.interiorColors[0].description}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="detail-section">
                <div class="detail-info inspection-survey" *ngIf="surveyData && surveyData.length>0">
                    <h3 class="h3-bgclass detail-head survey-icon">Vehicle Inspection Survey</h3>
                    <div class="detail-content">
                        <div class="survey-data" *ngFor="let survey of surveyData">
                            <div class="survey-col col-left">{{survey.name}}</div>
                            <div class="survey-col col-right text-center"
                                 [ngClass]="{'success': survey.status == 1, 'failure': survey.status == 0 || survey.status == 2}">
                                <span *ngIf="survey.status == 1"><i class="pi pi-check"></i>YES</span>
                                <span *ngIf="survey.status == 2 || survey.status == 0"><i class="pi pi-times"></i>NO</span>
                            </div>
                        </div>
                    </div>
                </div>

                <h3 class="recalibration-icon">Require Recalibration</h3>
                <div class="detail-info adas-system">
                    <!--<h3 class="detail-head adas-icon">Confirmed ADAS Systems</h3>-->
                    <h3 class="h3-bgclass detail-head adas-icon">Confirmed ADAS Systems</h3>

                    <div class="detail-content">
                        <p-accordion class="report-section custom-accordion flat-custom-accordion thread-detail-accordion"
                                     *ngFor="let item of resultData.features; let s = index;"
                                     (onClose)="onTabClose('section', item, s)" (onOpen)="onTabOpen('section', item, s)"
                                     [ngClass]="{'hide': item.categoryName == ''}">
                            <p-accordionTab id="section-{{s}}" class="section" [transitionOptions]="'100ms'"
                                            [selected]="item.isSelected">
                                <p-header class="sec-info">
                                    <div class="sec-title">
                                        <span class="sec-head truncate" title="{{item.categoryName}}">{{item.categoryName}}</span>
                                    </div>
                                </p-header>
                                <div class="content-list" id="cont-list-{{s}}">
                                    <div class="row col-12">
                                        <div class="col-12">
                                            <div class="content-info">
                                                <div class="info-label info-icon">Sub Category</div>
                                                <div class="info-val">{{item.subCategoryName}}</div>
                                            </div>
                                            <div class="content-info">
                                                <div class="info-label info-icon">Branded Feature Name</div>
                                                <div class="info-val">{{item.brandedFeatureName}}</div>
                                            </div>
                                            <!--<div *ngIf="roleId != 1" class="content-info">
                                                <div class="info-label info-icon">Feature ID</div>
                                                <div class="info-val">{{item.id}}</div>
                                            </div>-->
                                        </div>
                                    </div>
                                </div>

                            </p-accordionTab>
                        </p-accordion>
                        <div *ngIf="additionalSystemInfo.length > 0" class="asi">
                            <div class="asi-head">Additional</div>
                            <div class="asi-data" *ngFor="let systemInfo of additionalSystemInfo">{{systemInfo.name}}</div>
                        </div>
                    </div>
                </div>
                <div class="detail-info damage-info">
                    <h3 class="h3-bgclass detail-head attachment-icon">Vehicle Damage - Attachments</h3>
                    <div class="detail-content row justify-content-center">
                        <div class="demo-car col-12">
                            <div *ngFor="let position of damagePositions" class="position position-{{position.id}}"
                                 [ngClass]="{'active': position.damageFlag}">
                                <span class="position-item">{{position.id}}</span>
                                <span *ngIf="position.attachmentCount > 0" class="attach-count">{{position.attachmentCount}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="detail-info attachments" *ngFor="let damageAttachments of damagePositions"
                     [ngClass]="{'hide': damageAttachments.attachmentCount == 0}">
                    <div *ngIf="damageAttachments.damageFlag" class="atachment-item">
                        <h3>Position: {{damageAttachments.id}}</h3>
                        <div class="attachment-section">
                            <div class="content attachment-cont assets-list">
                                <app-attachment-view [dynamicGid]="damageAttachments.id" [access]="fileAccess" [action]="fileAction"
                                                     [hideLabel]="hideLabel"
                                                     [attachments]="damageAttachments.attachments"></app-attachment-view>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="notes != ''" class="detail-info notes">
                    <div class="notes-head">Notes:</div>
                    <div class="notes-info" [innerHTML]="notes"></div>
                </div>
                <!-- System Information -->
                <div class="reference-info">
                    <mat-accordion [multi]="true" #accordion="matAccordion">
                        <mat-expansion-panel class="{{panel.class}}"
                                             [disabled]="panel.isDisabled"
                                             [expanded]="panel.isExpanded"
                                             [hideToggle]="false"
                                             (opened)="beforeParentPanelOpened(panel, emptyList)"
                                             (closed)="beforeParentPanelClosed(panel, emptyList)"
                                             (afterCollapse)="afterPanelClosed()"
                                             (afterExpand)="afterPanelOpened()"
                                             *ngFor="let panel of referenceAccordion"
                                             #mapanel="matExpansionPanel">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <b>{{panel.title}}</b>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="app-accord">
                                <app-system-info-view [systemInfo]="systemInfo"></app-system-info-view>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
                <div class="report-footer">
                    <div class="row col-12">
                        <div class="col-6 col-md-6 col-sm-12 footer-col">
                            <ul>
                                <li class="rf-li domain-name">{{businessData.domainName}}</li>
                                <li class="rf-li vin">VIN: {{inspectionData.vinNo}}</li>
                                <li class="rf-li ro-id">Report ID: {{inspectionData.id}}</li>
                            </ul>
                        </div>
                        <div class="col-6 col-md-6 col-sm-12 footer-col">
                            <div class="text-right">Report by CalPro on Collabtic platform.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</ng-container>

<div *ngIf="thirdPartyReport.id" class="third-party-report">
    <div class="header-report">
        <div class="file-name">
            File Name: {{thirdPartyReport.name}}
        </div>
        <a class="original-report-btn" href="{{thirdPartyReport.link}}" target="_blank">
            <img src="assets/images/adas/report-download.svg" alt="" srcset="">
            <span>Download Original Report</span>
        </a>
    </div>
    <!-- <div class="loading-third-party" *ngIf="!thirdPartyReport.data">
        <img src="assets/images/landing-page/loading-more.svg" alt="Loader" />
    </div> -->
    <div class="third-party-data" *ngIf="!thirdPartyReport.data">
        Converted file data will show here, after the processing is complete.
    </div>
    <div class="third-party-data" *ngIf="thirdPartyReport.data">
        <div *ngFor="let page of thirdPartyReport.data" style="margin-bottom: 20px;padding-bottom: 5px;border-bottom: 1px solid #dedede;">
            <div class="detail-row outer" *ngIf="page?.page">
                <span class="detail-key">page</span>
                <span class="detail-sep">:</span>
                <span class="detail-value">{{page?.page}}</span>
            </div>
            <div class="detail-row outer" *ngIf="page?.client_name">
                <span class="detail-key">client_name</span>
                <span class="detail-sep">:</span>
                <span class="detail-value">{{page?.client_name}}</span>
            </div>
            <div class="detail-row outer" *ngIf="page?.output">
                <span class="detail-key">output</span>
            </div>
            <div class="order-detail">
                <!-- Loop through each section -->
                <div *ngFor="let sectionKey of objectKeys(page?.output)" style="padding-bottom: 5px;">
                    <h3>{{ sectionKey }}</h3>

                    <!-- Loop through inner keys -->
                    <div class="detail-row" *ngFor="let key of objectKeys(page?.output[sectionKey])">
                        <span class="detail-key">{{ key }}</span>
                        <span class="detail-sep">:</span>
                        <span class="detail-value">

                            <!-- If array of strings -->
                            <ng-container *ngIf="isArrayOfStrings(page?.output[sectionKey][key]); else checkObject">
                                {{ page?.output[sectionKey][key].join(', ') }}
                            </ng-container>

                            <!-- If nested object -->
                            <ng-template #checkObject>
                                <ng-container *ngIf="isObject(page?.output[sectionKey][key]); else normalValue">
                                    <div *ngIf="objectKeys(page?.output[sectionKey][key]).length > 1">&nbsp;</div>
                                    <div *ngFor="let subKey of objectKeys(page?.output[sectionKey][key])" style="padding-bottom: 4px;">
                                        <span style="color: #777;">{{ subKey }}</span> :

                                        <!-- If array of strings -->
                                        <ng-container *ngIf="isArrayOfStrings(page?.output[sectionKey][key][subKey]); else checkObjectIn">
                                            {{ page?.output[sectionKey][key][subKey].join(', ') }}
                                        </ng-container>

                                        <!-- If nested object -->
                                        <ng-template #checkObjectIn>
                                            <ng-container *ngIf="isObject(page?.output[sectionKey][key][subKey]); else normalValueIn">
                                                <div *ngFor="let subKeyIn of objectKeys(page?.output[sectionKey][key][subKey])"
                                                    style="padding-left: 20px; padding-bottom: 4px;">
                                                    <span style="color: #777;">{{ subKeyIn }}</span> : {{
                                                    isArrayOfStrings(page?.output[sectionKey][key][subKey][subKeyIn]) ?
                                                    page?.output[sectionKey][key][subKey][subKeyIn].join(', ') :
                                                    page?.output[sectionKey][key][subKey][subKeyIn] }}
                                                </div>
                                            </ng-container>
                                        </ng-template>

                                        <!-- Normal primitive value -->
                                        <ng-template #normalValueIn>
                                            {{ page?.output[sectionKey][key][subKey] }}
                                        </ng-template>
                                    </div>
                                </ng-container>
                            </ng-template>

                            <!-- Normal primitive value -->
                            <ng-template #normalValue>
                                {{ page?.output[sectionKey][key] }}
                            </ng-template>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
